import { ThemeProvider, CssBaseline, Box } from "@mui/material";
import theme from "./theme";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import WhoWeAre from "./components/WhoWeAre";
import Cases from "./components/Cases";
import ScrollToTopButton from "./components/ScrollToTopButton";
import Footer from "./components/Footer";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Navbar />
      <main>
        <Box component="section" id="hero"><Hero /></Box>
        <Box component="section" id="o-que-fazemos"><About /></Box>
        <Box component="section" id="quem-somos"><WhoWeAre /></Box>
        <Box component="section" id="cases"><Cases /></Box>
        <Box component="section" id="contato"><Footer /></Box>
        <ScrollToTopButton />
      </main>
    </ThemeProvider>
  );
}